/** TryOnMe mark: hanger with a "+" on a rounded green tile, and the wordmark. */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" className="logo-mark">
      <rect width="40" height="40" rx="11" fill="#0D6B4F" />
      <path
        d="M20 15.2v-1a2.6 2.6 0 1 0-2.6-2.6M20 15.2 9.6 22.6a1.4 1.4 0 0 0 .8 2.6h19.2a1.4 1.4 0 0 0 .8-2.6Z"
        fill="none"
        stroke="#fff"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M29 7.5v6M26 10.5h6" stroke="#E36B3A" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  )
}

export function Wordmark() {
  return (
    <span className="wordmark">
      TryOn<span>Me</span>
    </span>
  )
}
